import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SteuernApiService } from '../pages/steuern/services/steuern-api.service';
import { STEUERN_STEP_ORDER } from '../pages/steuern/services/steuern-storage.service';
import type { SteuernOverviewHighlightId } from '../pages/steuern/services/steuern-storage.service';

export const steuernStepOrderGuard: CanActivateFn = (_, state) => {
  const router = inject(Router);
  const steuernApi = inject(SteuernApiService);

  const path = state.url.split('?')[0].replace(/^\/+/, '');
  const segment = path.startsWith('steuern/') ? path.slice('steuern/'.length).split('/')[0] : '';
  if (segment === '') return true;

  if (segment === 'overview') {
    if (steuernApi.isStepDataComplete('personal-information')) return true;
    return router.createUrlTree([steuernApi.getFirstIncompleteStepPath()]);
  }

  const stepId = segment as SteuernOverviewHighlightId;
  if (!STEUERN_STEP_ORDER.includes(stepId)) return true;

  const viewOnlyRequested = state.url.includes('viewOnly=true');
  if (viewOnlyRequested && steuernApi.isViewOnlyStepAccessAllowed()) return true;

  if (steuernApi.isStepUnlocked(stepId)) return true;
  return router.createUrlTree([steuernApi.getFirstIncompleteStepPath()]);
};
